var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_93566",
    "data-name": "Path 93566",
    d: "M7.744,6.371,1.515.251a.913.913,0,0,0-1.259,0,.874.874,0,0,0,0,1.237L5.867,7,.256,12.512a.875.875,0,0,0,0,1.237.913.913,0,0,0,1.259,0L7.744,7.608A.874.874,0,0,0,7.744,6.371Z",
    transform: "translate(14) rotate(90)",
    fill: "#1f1f1f",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.14fcb899865d49c8a624bbf534389145.svg";
export { ForwardRef as ReactComponent };